import jwtDecode from 'jwt-decode';
import ls from 'localstorage-slim';
import Roles from '../constants/Roles';

const getUserToken = () => {
  const usrData = ls.get('gai-token');
  return usrData;
};

const getUserRole = () => {
  const gaiRole = ls.get('gai-role', {decrypt: true});
  // const roleKey = Object.keys(Roles).find(key => object[key] === roleValue);
  return gaiRole;
};

// If they only have client permissions
const isClientPersonnelOnly = () => {
  const roles = getUserRole();
  if (!Array.isArray(roles)) {
    return roles === Roles.CLIENT_PERSONNEL;
  }
  return false;
};

const isAdmin = () => {
  return roleContains(Roles.ADMIN);
};

const isSales = () => {
  return roleContains(Roles.GRAYSTONE_SALES);
};

const isDataEntry = () => {
  return roleContains(Roles.GRAYSTONE_DATA_ENTRY);
};

const roleContains = roleType => {
  const roles = getUserRole();
  if (Array.isArray(roles)) {
    // If the user has multiple roles it's an array, otherwise it's a string.  Too late to add typescript to this project.
    return roles?.find(r => r?.toLowerCase().includes(roleType.toLowerCase()));
  } else if (typeof roles === 'string' || roles instanceof String) {
    return roles?.toLowerCase().includes(roleType.toLowerCase());
  }
  return false;
};

const setUserToken = (token, expires = 43200) => {
  ls.set('gai-token', token, {ttl: expires});
};

const setUserRole = (roleName, expires = 43200) => {
  ls.set('gai-role', roleName, {ttl: expires, encrypt: true});
};

const getUsername = () => {
  const usr = ls.get('gai-token');
  if (usr) {
    const usrData = jwtDecode(usr);
    return usrData.name;
    // return usrData.displayname
  } else {
    return null;
  }
};

const getUserInfo = () => {
  const usrData = ls.get('gai-token');
  const info = usrData ? jwtDecode(usrData) : null;
  return info;
};

// Set default expiration to 12 hours
const set = (key, value, expiration = 43200) => {
  return key, value, {ttl: expiration, encrypt: true};
};

const get = key => {
  return ls.get(key, {decrypt: true});
};

const clearAll = () => {
  ls.clear();
};

export {
  getUserToken,
  getUsername,
  getUserRole,
  getUserInfo,
  set,
  get,
  clearAll,
  setUserRole,
  setUserToken,
  roleContains,
  isClientPersonnelOnly,
  isAdmin,
  isSales,
  isDataEntry,
};
